import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// `withCredentials: true` ensures the browser sends/receives the HttpOnly
// admin session cookie on cross-origin same-site requests.
export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
  withCredentials: true,
});

// Public
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const subscribeNewsletter = (payload) => api.post("/newsletter", payload).then((r) => r.data);
export const fetchStats = () => api.get("/stats").then((r) => r.data);
export const fetchPosts = (params = {}) => api.get("/posts", { params }).then((r) => r.data);
export const fetchPost = (slug) => api.get(`/posts/${slug}`).then((r) => r.data);

// Admin (HttpOnly session-cookie auth — no JS-readable token).
export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password }).then((r) => r.data);
export const adminLogout = () => api.post("/admin/logout").then((r) => r.data);
export const adminVerify = () => api.post("/admin/verify").then((r) => r.data);
export const adminListPosts = () => api.get("/admin/posts").then((r) => r.data);
export const adminCreatePost = (body) => api.post("/admin/posts", body).then((r) => r.data);
export const adminUpdatePost = (id, body) => api.put(`/admin/posts/${id}`, body).then((r) => r.data);
export const adminDeletePost = (id) => api.delete(`/admin/posts/${id}`).then((r) => r.data);
export const adminListContacts = (params = {}) => api.get("/contact", { params }).then((r) => r.data);
export const adminContactStats = () => api.get("/admin/contact/stats").then((r) => r.data);
